import { XMarkRegularIcon } from "@elixir/icons";
import { Modal } from "antd";
import HprHfrOnboarding from "../../../pages/hpr-hfr-onboarding";
import useHprHfrOnboardingStore from "../../../stores/hpr-hfr-dhis-onboarding";
import { EKA_EVENT, EVENT_TYPES } from "../../../utils/bridges";
import { OnboardingNavigationStates } from "../../../stores/hpr-hfr-dhis-onboarding/enums";

export const HprHfrOnboardingModal = () => {
  const open = useHprHfrOnboardingStore((state) => state.openModal);
  const setOpen = useHprHfrOnboardingStore((state) => state.setOpenModal);
  const activeScreen = useHprHfrOnboardingStore((state) => state.activeScreen);
  const subActiveScreen = useHprHfrOnboardingStore(
    (state) => state.subActiveScreen
  );
  const clearHprHfrStore = useHprHfrOnboardingStore(
    (state) => state.clearHprHfrStore
  );

  const handleClose = () => {
    if (
      [
        OnboardingNavigationStates.AADHAR,
        OnboardingNavigationStates.HFR_CREATION_COMPLETED,
      ].includes(activeScreen)
    ) {
      setOpen(false);
      clearHprHfrStore();
      dispatchEvent(
        new CustomEvent(EKA_EVENT, {
          detail: {
            type: EVENT_TYPES.CLOSE_HPR_HFR_ONBOARDING,
          },
        })
      );
    } else {
      Modal.confirm({
        title: "Are you sure you want to close the onboarding?",
        onOk: () => {
          setOpen(false);
          clearHprHfrStore();
          dispatchEvent(
            new CustomEvent(EKA_EVENT, {
              detail: {
                type: EVENT_TYPES.CLOSE_HPR_HFR_ONBOARDING,
              },
            })
          );
        },
        zIndex: 2000,
        centered: true,
      });
    }
  };

  return (
    <Modal
      style={{
        padding: 0,
        borderRadius: "0.5rem",
        overflow: "hidden",
        minWidth: "70vw",
      }}
      bodyStyle={{ padding: 0 }}
      footer={null}
      closable={false}
      open={open && !subActiveScreen}
      zIndex={1100}
    >
      <div
        className="dr-w-24 dr-h-24 dr-flex dr-items-center dr-justify-center dr-rounded-full dr-z-2 dr-absolute dr-top-16 dr-right-16 dr-cursor-pointer"
        onClick={handleClose}
      >
        <XMarkRegularIcon className="dr-w-16 dr-h-16" />
      </div>
      <HprHfrOnboarding />
    </Modal>
  );
};
